// Query history / audit log HTTP wrappers.
import { api } from './api.js';

// The caller's own query-tab statements (recall list).
export async function listMyHistory(limit = 60, q = '') {
  const params = new URLSearchParams();
  if (limit) params.set('limit', String(limit));
  if (q) params.set('q', q);
  const r = await api.get(`/api/me/history?${params.toString()}`);
  return r.entries || [];
}

// Full audit log (admin). `filters` keys: userId, connectionId, kind, success,
// q, database, after, before, limit, offset. Returns { entries, total }.
export async function listAuditHistory(filters = {}) {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v !== '' && v !== null && v !== undefined) params.set(k, String(v));
  }
  return api.get(`/api/history?${params.toString()}`);
}

export async function pruneHistory(olderThanDays) {
  return api.post('/api/history/prune', { olderThanDays });
}
